<template>
  <v-container
    class="degrade d-flex flex-column align-center justify-center pa-5"
    fluid
  >
    <a href="/" class="d-flex align-center justify-center width-100">
      <v-img
        max-width="25rem"
        height="13.75rem"
        width="100%"
        contain
        src="@/assets/Logo VcomNet.png"
      ></v-img>
    </a>

    <ul class="d-flex flex-wrap">
      <li>
        <Headerbutton :label="'Planos'" :modal="true"></Headerbutton>
      </li>
      <li>
        <Headerbutton
          :label="'Assinante'"
          :to="'https://vcomnet.sgp.tsmx.com.br/central'"
        ></Headerbutton>
      </li>
      <li>
        <Headerbutton :label="'Contato'" :to="'/contato'"></Headerbutton>
      </li>
      <li v-if="false">
        <Headerbutton :label="'Suporte'"></Headerbutton>
      </li>
      <li v-if="false">
        <Headerbutton :label="'Sobre'"></Headerbutton>
      </li>
      <li>
        <Headerbutton
          :label="'Teste de velocidade'"
          :to="'https://www.minhaconexao.com.br'"
          :target="'_blank'"
        ></Headerbutton>
      </li>
    </ul>
  </v-container>
</template>
<script>
import Headerbutton from './Headerbutton.vue'
export default {
  name: 'PrincipalHeader',
  components: { Headerbutton },
}
</script>
<style scoped>
.degrade {
  background: linear-gradient(to top, #ffffff00 0%, #e7e7e7 100%);
}
</style>
